import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ClearTaxUseCase extends BaseUseCase {
    constructor(taxReportRepo) {
        super();
        this.taxReportRepo = taxReportRepo;
    }
    async fetchResult(req) {
        return await this.taxReportRepo.clearTaxRedirect(req);
    }
}
export default ClearTaxUseCase;
